import React from "react";
import {connect} from "react-redux";
import {Form, Formik} from "formik";
import {traerPalabrasTabla} from "../../_actions";
import {buscadorConstants} from "../../_constants";
import Moment from "react-moment";
import MiTabla from "../../_helpers/MiTabla";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-router-dom";
import authService from "../../_services/cart/authService";
import {history, prepareDataSearch} from "../../_helpers";
import http from '../../_services/cart/http.service';
import alertService from "../../_services/cart/alert.service";
import {NavBarLateral} from "../includes";
import ReactSwitch from "react-switch";

const tableRefUsers = React.createRef();

const bagRef = React.createRef();
const _ = require("lodash");

class AlertasList extends React.Component {
    constructor(props) {
        super(props);
        this.state.nuevo = _.clone(buscadorConstants.infoTablaDefault);
    }

    state = {
        loading: false,
        nuevaBusqueda: false,
        show: false,
        producto: {},
        showUser: false,
    };

    componentDidMount() {

    }

    toogleActivo = (row) => {
        let body = {
          id: row.id
        };
    
        http
          .post("api/alertas/toogle", body)
          .then((data) => {
            this.actualizar();
          })
          .catch((error) => {
            alertService.error(error);
          });
      };

    actualizar = () => {
        if (tableRefUsers.current) {
            tableRefUsers.current.onQueryChange();
        }
    };

    actualizarPageSize = (newPageSIze) => {

        if (tableRefUsers.current) {
            tableRefUsers.current.dataManager.changePageSize(newPageSIze)
        }

    };

    handleClose = () => {
        this.setState({
            showUser: false,
            producto: undefined,
            alert: undefined,
        });
    };

    buscarData = (query) => {
        return new Promise((resolve, reject) => {
            if (this.state.nuevaBusqueda) query.page = 0;

            http.post('/api/alertas/buscar',
                prepareDataSearch(query, "createdDate", "DESC", this.state.values))
                .then(
                    (data) => {
                        this.setState({nuevaBusqueda: false});
                        resolve({
                            data: data.content ? data.content : [],
                            page: query.page,
                            totalCount: data ? data.totalElements : 0,
                        });
                        this.actualizarPageSize(query.pageSize);
                    },
                    (error) => {
                        alertService.error(error);
                    }
                );
        });
    };

    render() {

        const {loading} = this.state;

        const header = [        
            {
                title: "Tipo Repuesto",
                render: (row) => (
                    <span>
                          {row.tipoRepuesto && row.tipoRepuesto.nombre?row.tipoRepuesto.nombre:'Todos'}
                    </span>
                )
            },    
            {
                title: "Marca",
                field: "marca.nombre"
            },
            {
                title: "Modelo",
                field: "modelo.nombre"
            },
            {
                title: "Versión",
                field: "version.nombre"
            },
            {
                title: "Activo", field: "active",
                render: (row) => (
                    <span>
                          <ReactSwitch
                            onChange={(event) => {
                              this.toogleActivo(row);
                            }}
                            checked={row.active}
                            onColor="#FF962E"
                          />
                    </span>
                )
            }
        ];

        const options = {
            search: true,
            sorting: true,
            fontSize: 6,
            filtering: false,
            selection: false,
            pageSize: this.state.nuevo.limit,
            pageSizeOptions: [5, 10, 25, 30, 50, 75, 100],
            exportAllData: true,
            overflowX: "auto",
            tableLayout: "auto",
        };

        let inic = {
        };

        return (
            <>
                <div className="dashboard">
                    <NavBarLateral handleClose={this.handleClose}/>
                    <div className="dashboard__content">
                        <Formik
                            enableReinitialize={true}
                            innerRef={bagRef}
                            initialValues={inic}
                            onSubmit={(values) => {
                                this.setState(
                                    {
                                        values: values,
                                        nuevaBusqueda: true
                                    },
                                    this.actualizar
                                );
                            }}
                        >
                            {({values, setFieldValue, submitForm}) => (
                                <Form>
                                    <div className="dashboard__content-header">
                                        <div className="dashboard__content-title">
                                            <h2>Alertas</h2>
                                        </div>
                                    </div>

                                    <div className="dashboard__content-header">
                                        <div className="dashboard__content-title">
                                            <p>
                                                Cuando se publique algo que coincida con una de tus alertas te avisamos al instante: te llega una notificación al celular, aparece en la campanita del sitio y además te mandamos un mail.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="dashboard__content-main--tab">
                                        <MiTabla
                                            title=""
                                            tableRef={tableRefUsers}
                                            columns={header}
                                            options={options}
                                            style={{
                                                tableLayout: "auto",
                                                width: "100%",
                                                maxWidth: "100%",
                                                height: "auto",
                                                borderRadius: "1rem",
                                                border: "1px solid #d2d2d2",
                                                boxShadow: 'none',
                                                backgroundColor: 'inherit',
                                                color: 'inherit'
                                            }}
                                            data={(query) => this.buscarData(query, false)}
                                            localization={traerPalabrasTabla("Alertas")}
                                        />
                                    </div>
                                </Form>
                            )}
                        </Formik>

                        {this.state.alert}
                    </div>
                </div>
            </>
        );
    }
}

function mapState(state) {
    const {filtros} = state.busqueda;
    return {filtros};
}

const actionCreators = {};

const connectedAlertasList = connect(mapState, actionCreators)(AlertasList);
export {connectedAlertasList as AlertasList};
